import { render, staticRenderFns } from "./VuesticColorSquare.vue?vue&type=template&id=6c92223f"
import script from "./VuesticColorSquare.vue?vue&type=script&lang=js"
export * from "./VuesticColorSquare.vue?vue&type=script&lang=js"
import style0 from "./VuesticColorSquare.vue?vue&type=style&index=0&id=6c92223f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports